import { render, staticRenderFns } from "./CsvReader.vue?vue&type=template&id=ede4e2ac&scoped=true"
import script from "./CsvReader.vue?vue&type=script&lang=js"
export * from "./CsvReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede4e2ac",
  null
  
)

export default component.exports